import { render, staticRenderFns } from "./DealPicto.vue?vue&type=template&id=339fe6d4&"
import script from "./DealPicto.vue?vue&type=script&lang=js&"
export * from "./DealPicto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports